import { createFileRoute } from '@tanstack/react-router';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { DatConversionListPage } from '@/pages/dat-conversion/ui/DatConversionListPage';

/**
 * dat変換ルート
 */
export const Route = createFileRoute('/_protected/dat-conversion/')({
  component: DatConversionListPage,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
});
